
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us",
      function () {
        return require("private-next-pages/about-us.js");
      }
    ]);
  